<template>
  <clinician-app-layout :showIntercomCheckList="!$page.props.isAdmin">
    <div class="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-6">
      <action-message :on="$page.props.message" />
      <action-message :on="$page.props.error" error />
      <home />
    </div>
  </clinician-app-layout>
</template>

<script>
import ClinicianAppLayout from '@/Layouts/ClinicianAppLayout.vue';
import Home from './Home.vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';
import useTourManager from '@/Composables/useTourManager';
import { clinicianDashboardSteps } from '@/Data/tourSteps';

const clinicianDashboardTour = useTourManager('clinicianDashboardTour', clinicianDashboardSteps);

export default {
  components: {
    ClinicianAppLayout,
    Home,
    ActionMessage,
  },
  mounted() {
    setTimeout(() => {
      clinicianDashboardTour.startTour();
    }, 500);
  },
  methods: {
    logout() {
      this.$inertia.post(route('logout'));
    },
  },
};
</script>
